import {
  Checkbox,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  Typography,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { MdaSelectOption } from "./mda-types";

interface MdaClaimStatusFilterProps {
  values: string[];
  options: MdaSelectOption[];
  loading: boolean;
  onChange: (claimStatuses: string[]) => void;
}

const MdaClaimStatusFilter = ({
  values,
  options,
  loading,
  onChange,
}: MdaClaimStatusFilterProps) => {
  const allClaimStatusValues = options.map((status) => status.value);
  const hasAllClaimStatusesSelected =
    Boolean(allClaimStatusValues.length) &&
    allClaimStatusValues.every((status) => values.includes(status));

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const { value } = event.target;

    const selectedValues = typeof value === "string" ? value.split(",") : value;

    if (selectedValues.includes("")) {
      onChange(hasAllClaimStatusesSelected ? [] : allClaimStatusValues);
      return;
    }

    onChange(selectedValues);
  };

  const getValueLabel = (selected: string[]) => {
    if (!selected.length) return "Select claim statuses";

    const statusLabel = selected.length === 1 ? "status" : "statuses";

    return `${selected.length} ${statusLabel} selected`;
  };

  return (
    <Stack spacing={0.8}>
      <Typography variant="caption" sx={{ color: "#24344d", fontWeight: 700 }}>
        Claim Status
      </Typography>
      <Select
        multiple
        value={values}
        onChange={handleChange}
        size="small"
        IconComponent={KeyboardArrowDownIcon}
        disabled={loading}
        displayEmpty
        renderValue={(selected) => (
          <Typography
            component="span"
            sx={{ color: "#46566e", fontSize: "0.875rem" }}
          >
            {getValueLabel(selected)}
          </Typography>
        )}
      >
        <MenuItem value="">
          <Checkbox checked={hasAllClaimStatusesSelected} size="small" />
          <ListItemText
            primary={loading ? "Loading statuses..." : "All statuses"}
          />
        </MenuItem>
        {options.map((status) => (
          <MenuItem key={status.value} value={status.value}>
            <Checkbox checked={values.includes(status.value)} size="small" />
            <ListItemText primary={status.label} />
          </MenuItem>
        ))}
      </Select>
    </Stack>
  );
};

export default MdaClaimStatusFilter;
